import * as Sentry from '@sentry/nextjs'
import posthog from 'posthog-js'
import { useMemo } from 'react'
import { ProfileFragment } from '../graphql/profile/profile.fragment'
import { useProfileQuery } from '../graphql/profile/profile.query'
import { useAppSelector } from '../store'

interface Profile {
  profile?: ProfileFragment
  loading: boolean
}

export const useProfile = (): Profile => {
  const authenticated = useAppSelector((state) => state.auth.authenticated)
  const email = useAppSelector(state => state.auth.email)

  const { loading, data } = useProfileQuery({
    onCompleted(data) {
      if (data) {
        posthog.identify(
          data.user.id,
          {
            email: data.user.email,
            first_name: data.user.firstName,
            last_name: data.user.lastName,
          },
        )
        Sentry.setUser({
          email: data.user.email,
          id: `${data.user.id}`,
        })
      }
    },
    skip: !authenticated,
  })

  const profile = useMemo(() => {
    if (data?.user) {
      return data.user
    }

    return {
      email,
    } as ProfileFragment
  }, [data])

  return {
    loading,
    profile,
  }
}
